module.exports = {
  model: { id: '', name: null, due_day: null, description: null },
  required: ['name', 'due_day', 'description']
}
